import Bid from '../helpers/Bid';

;$(function() {

    var lot = {};
    lot.plus = '[data-bid-plus]';
    lot.minus = '[data-bid-minus]';
    lot.value = '[data-bid-value]';
    lot.bid = '[data-bid-make]';

    $(document).on('mousedown', lot.value, function (e) {
        e.target.focus();
    });

    var actions = {};
    actions.increase = function() {
        var id = $(this).parents('[data-bid]').eq(0).attr('data-lot');
        var bid = new Bid(id);
        bid.increase();
        bid.update();
    };
    actions.decrease = function() {
        var id = $(this).parents('[data-bid]').eq(0).attr('data-lot');
        var bid = new Bid(id);
        bid.decrease();
        bid.update();
    };
    actions.value = function() {
        var id = $(this).parents('[data-bid]').eq(0).attr('data-lot');
        var bid = new Bid(id);
        bid.change();
        // bid.update();
    };
    actions.bid = function() {
        var id = $(this).parents('[data-bid]').eq(0).attr('data-lot');
        var bid = new Bid(id);
        bid.bid();
    };

    $(document).on('click', lot.plus, actions.increase );
    $(document).on('click', lot.minus, actions.decrease );
    $(document).on('keyup', lot.value, actions.value );
    $(document).on('click', lot.bid, actions.bid );

    $('.card__main-item:last-child').click(function(e) {
        e.preventDefault();
    });

});